import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
    auth: {
        clientId: 'b1f8ddfa-6663-4192-9137-5c30eb6673ae',
        authority: 'https://login.microsoftonline.com/2b21e8b5-c462-4f9d-952f-f47b9456b623',
        redirectUri: 'https://prod.finanzam.com/', // Ensure this matches your Azure AD settings
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: true // Helps with cross-browser issues
    }
};

const loginRequest = {
    scopes: ['User.Read', 'GroupMember.Read.All']
};

const msalInstance = new PublicClientApplication(msalConfig);

// Ensure we handle the redirect response properly
msalInstance.handleRedirectPromise().then((response) => {
    if (response !== null && response.account) {
        console.log("Authorization Code Flow successful:", response);
    }
}).catch(error => {
    console.error("Redirect error:", error);
});

export { msalInstance, loginRequest };
